module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-for-sale-property-cluster-pin-9795532268daa0e8f19747be8c8f793a.svg";